<template>
  <RfDashboard />
</template>

<script setup>
import RfDashboard from "@/views/RfDashboard/RfDashboard.vue";
</script>
